import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, combineLatest, of } from 'rxjs';
import { catchError, filter, map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permission.service';
import { Permission } from '../enums/permission.enum';

export const MANAGER_ACCESS_PERMISSIONS = [Permission.MANAGER_READ, Permission.MANAGER_WRITE] as const;
export const REVIEW_IMPACT_READ_PERMISSIONS = [Permission.MANAGER_READ, Permission.MANAGER_WRITE, Permission.MANAGER_PEOPLE, Permission.PEOPLE_READ, Permission.PEOPLE_WRITE, Permission.DIRECTOR_READ, Permission.DIRECTOR_WRITE, Permission.EVALUATION_WRITE] as const;
export const REVIEW_IMPACT_CHANGE_PERMISSIONS = [Permission.DIRECTOR_READ, Permission.DIRECTOR_WRITE, Permission.MANAGER_PEOPLE, Permission.PEOPLE_READ, Permission.EVALUATION_WRITE] as const;

/** Additional Manager gate; the existing page read/write permissions still apply. */
@Injectable({ providedIn: 'root' })
export class PerformanceManagerGuard implements CanActivate {
  constructor(
    private readonly auth: AuthService,
    private readonly permissions: PermissionService,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    if (!this.auth.isLoggedIn()) return of(this.router.createUrlTree(['/auth']));
    return combineLatest([this.permissions.ready$, this.permissions.permissions$]).pipe(
      filter(([ready]) => ready || !this.auth.isLoggedIn()),
      take(1),
      map(() => {
        if (!this.auth.isLoggedIn()) return this.router.createUrlTree(['/auth']);
        return this.permissions.hasAnyPermission(MANAGER_ACCESS_PERMISSIONS)
          ? true : this.router.createUrlTree(['/staffing/dashboard']);
      }),
      catchError(() => of(this.router.createUrlTree(['/staffing/dashboard']))),
    );
  }
}
